import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "hasSeparator", "id", "isList", "isScrollable", "overrides", "testId", "title"];
import React from 'react';
import Section from '@atlaskit/menu/section';
import { CheckboxGroupContext } from '../internal/context/checkbox-group-context';
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */
var DropdownItemCheckboxGroup = function DropdownItemCheckboxGroup(_ref) {
  var children = _ref.children,
    hasSeparator = _ref.hasSeparator,
    id = _ref.id,
    isList = _ref.isList,
    isScrollable = _ref.isScrollable,
    overrides = _ref.overrides,
    testId = _ref.testId,
    title = _ref.title,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CheckboxGroupContext.Provider, {
    value: id
  }, /*#__PURE__*/React.createElement(Section, _extends({
    hasSeparator: hasSeparator,
    id: id,
    isList: isList,
    isScrollable: isScrollable
    // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
    ,
    overrides: overrides,
    testId: testId,
    title: title
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, rest), children));
};
export default DropdownItemCheckboxGroup;